module.exports = __webpack_public_path__ + "img/abkhazia.c6427842.svg";